import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = { class: "content-section cta-section" }
const _hoisted_4 = { class: "cta-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppLayout = _resolveComponent("AppLayout")!

  return (_openBlock(), _createBlock(_component_AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Главная", -1)
            ]))]),
            _: 1
          }),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, " → ", -1)),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "О компании", -1))
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "page-title" }, "О компании", -1)),
        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "intro-text" }, " Двери производства «ПСК Монтаж» — это прекрасно зарекомендовавшая себя продукция премиум класса. Качество является корпоративной идеей компании. ", -1)),
        _cache[10] || (_cache[10] = _createElementVNode("section", { class: "content-section" }, [
          _createElementVNode("h2", null, "Наша философия"),
          _createElementVNode("p", null, " Постоянное развитие оригинальных идей и решений всегда было характерной чертой компании. Предприятие за время работы освоило выпуск десятков наименований продукции с различными функциями, но обязательно выполненной по индивидуальным размерам. ")
        ], -1)),
        _cache[11] || (_cache[11] = _createElementVNode("section", { class: "content-section" }, [
          _createElementVNode("h2", null, "Индивидуальный подход"),
          _createElementVNode("p", null, " Учитывая разнообразие специальных комплектующих и отделочных материалов, трудно найти среди тысяч выполненных объектов два одинаковых. Весь персонал компании нацелен на поиск и освоение нового продукта, постоянно изучаются достижения в разработке инновационных технологий, комплектующих и материалов, а индивидуальность позволяет гарантировать выполнение заказа любой сложности. ")
        ], -1)),
        _createElementVNode("section", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _cache[5] || (_cache[5] = _createTextVNode(" Ознакомьтесь с нашим ", -1)),
            _createVNode(_component_router_link, { to: "/catalog" }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("каталогом продукции", -1)
              ]))]),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createTextVNode(" или перейдите в раздел ", -1)),
            _createVNode(_component_router_link, { to: "/contacts" }, {
              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                _createTextVNode("контактов", -1)
              ]))]),
              _: 1
            }),
            _cache[7] || (_cache[7] = _createTextVNode(" для уточнения деталей и оформления заказа. ", -1))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}